const SELECTOR = '[data-event]';

class Analytics {
    #providers = [];

    #captureClicks() {
        document.addEventListener('click', (e) => {
            const el = e.target.matches(SELECTOR) ? e.target : e.target.closest(SELECTOR);
            if (!el) return;

            const { event, ...params } = el.dataset;
            this.trackEvent(event, params);
        }, { capture: true, passive: true });
    }

    #captureHistory() {
        window.addEventListener('popstate', () => {
            this.trackPageView();
        });
    }

    registerProvider(provider) {
        this.#providers.push(provider);
    }

    async initialize() {
        await Promise.allSettled(
            this.#providers.map((provider) => provider.initialize())
        );

        this.trackPageView();
        this.#captureClicks();
        this.#captureHistory();
    }

    async trackPageView() {
        await Promise.allSettled(
            this.#providers.map((provider) => provider.trackPageView())
        );
    }

    async trackEvent(eventName, eventParams) {
        await Promise.allSettled(
            this.#providers.map((provider) => provider.trackEvent(eventName, eventParams))
        );
    }

    async setUserId(userId) {
        await Promise.allSettled(
            this.#providers.map((provider) => provider.setUserId(userId))
        );
    }

    async setEmail(email) {
        await Promise.allSettled(
            this.#providers.map((provider) => provider.setEmail(email))
        );
    }

    async setUserProperties(properties) {
        await Promise.allSettled(
            this.#providers.map((provider) => provider.setUserProperties(properties))
        );
    }
}

export default Analytics;
